export default __webpack_public_path__ + "static/horizontal-logo-f27fe80f48f8404a960ec1954151f94c.svg";